<template>
	<div id="careers" class="careers" :class="{ 'is-sticky': isSticky }">
		<div class="careers__header">
			<div class="hero">
				<div class="hero-image"></div>
				<div class="hero-content">
					<div class="hero-body">
						<div class="hero-title">
							{{ $t('main.careers.hero-title') }}
						</div>
						<div class="hero-statement">
							{{ $t('main.careers.hero-statement') }}
						</div>
					</div>
				</div>
				<div class="hero-badge"></div>
			</div>

			<div ref="header-tabs" class="careers__header__tabs" :class="{ 'careers__header__tabs--sticky': isSticky }">
				<div class="tab" @click="scrollToId('open-positions')">{{ $t('main.careers.open-positions') }}</div>
				<div class="tab" @click="scrollToId('benefits-and-perks')">{{ $t('main.careers.benefits-and-perks') }}</div>
				<div class="tab" @click="scrollToId('featured-jobs')">{{ $t('main.careers.featured-jobs') }}</div>
				<div class="tab" @click="scrollToId('life-at-nexon')">{{ $t('main.careers.life-at-nexon') }}</div>
			</div>
		</div>

		<div id="open-positions" class="careers__section">
			<div class="careers__section__title">
				{{ $t('main.careers.open-positions') }}
			</div>
			<div
				data-font-size="16px"
				data-group-by="department"
				data-show-searchbar-count="-1"
				data-wp-plugin="true"
				class="jobscore-jobs"
			>
				<div style="color:#888" class="js-fallback">
					<a href="https://careers.jobscore.com/jobs/nexonamericainc" style="color:#888;text-decoration:underline;">
						{{ $t('main.careers.nexon-inc-jobs') }}
					</a>
					{{ $t('main.careers.powered-by') }}
					<a href="https://www.jobscore.com/" style="color:#888"
						><img
							align="bottom"
							alt="Applicant Tracking, Social Recruiting and Software Hiring Solution - JobScore"
							src="https://careers.jobscore.com/images/new/jobscore_logo_embed.png"
							style="padding:0;"
					/></a>
				</div>
			</div>
		</div>

		<div id="benefits-and-perks" class="careers__section">
			<div class="careers__section__title">
				{{ $t('main.careers.benefits-and-perks') }}
			</div>
			<div class="benefits">
				<div class="benefits__grid">
					<div v-for="(benefit, index) in benefits" :key="index" class="benefit">
						<div class="benefit__title" :class="`benefit__title--${language}`">
							{{ $t(`main.careers.benefits.${benefit}-title`) }}
						</div>
						<div class="benefit__icon">
							<img :src="require(`@/images/corporate/careers/icons/benefit-${benefit}.png`)" />
						</div>
						<div class="benefit__detail" :class="`benefit__detail--${language}`">
							{{ $t(`main.careers.benefits.${benefit}-detail`) }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="featured.length > 0" id="featured-jobs" class="careers__section">
			<div class="careers__section__title">
				{{ $t('main.careers.featured-jobs') }}
			</div>

			<div class="featured-carousel">
				<VueSlickCarousel v-bind="jobsSliderSettings">
					<div v-for="(item, index) in featured" :key="index">
						<div class="featured-carousel__item">
							<div
								class="featured-carousel__item__left"
								:style="{ backgroundImage: `url(${require(`@/images/corporate/careers/featured-${index + 1}.jpg`)})` }"
							></div>
							<div class="featured-carousel__item__right">
								<div class="featured">
									<div class="featured__title">{{ item.title }}</div>
									<div class="featured__subtitle">{{ item.department }} IN {{ item.location }}</div>
									<div class="featured__description">
										{{ item.custom_fields.filter((i) => i.label === 'Job Summary').pop().content }}
									</div>
									<a class="featured__apply" :href="item.detail_url">{{ $t('main.careers.apply-now') }}</a>
								</div>
							</div>
						</div>
					</div>
				</VueSlickCarousel>
			</div>
		</div>

		<div id="life-at-nexon" class="careers__section">
			<div class="careers__section__title">
				{{ $t('main.careers.life-at-nexon') }}
			</div>

			<div class="life-carousel">
				<VueSlickCarousel v-bind="lifeAtNexon.settings">
					<div v-for="(item, index) in lifeAtNexon.images" :key="index" class="life-carousel__item">
						<img :src="require(`@/images/corporate/careers/${item}.jpg`)" />
					</div>
				</VueSlickCarousel>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';

export default {
	components: {
		VueSlickCarousel,
	},
	metaInfo() {
		return {
			titleTemplate: `%s | ${this.$t('main.about-nexon.careers')}`,
		};
	},
	data() {
		return {
			scrollY: 0,
			joblist: {},
			benefits: [
				'health',
				'401k',
				'learning',
				'work',
				'medical',
				'referral',
				'transportation',
				'employee-dc',
				'social',
				'extra-service',
				'pet',
				'meals',
				'nxercise',
				'nxcash',
			],
			jobsSliderSettings: {
				infinite: true,
				speed: 500,
				slidesToShow: 1,
				slidesToScroll: 1,
				fade: true,
				dots: true,
				arrows: true,
				adaptiveHeight: true,
			},
			lifeAtNexon: {
				images: ['nx-01', 'nx-02', 'nx-03', 'nx-04', 'nx-05', 'nx-06'],
				settings: {
					infinite: true,
					speed: 500,
					slidesToShow: 1,
					slidesToScroll: 1,
					fade: true,
					arrows: true,
					dots: true,
					adaptiveHeight: true,
				},
			},
		};
	},
	computed: {
		isSticky() {
			return this.scrollY >= 790;
		},
		featured() {
			if (this.joblist && this.joblist.jobs) {
				return this.joblist.jobs
					.filter((item) => item.custom_fields.filter((i) => i.label === 'Featured').pop().content == 'Yes')
					.sort((a, b) => new Date(b.created_on) - new Date(a.created_on))
					.slice(0, 5);
			}
			return [];
		},
		language() {
			return this.$i18n.locale;
		},
	},
	mounted() {
		// initiate the jobscore widget list display
		(function(d, s, c) {
			if (window._jobscore_loader) {
				return;
			} else {
				window._jobscore_loader = true;
			}
			var o = d.createElement(s);
			o.type = 'text/javascript';
			o.async = true;
			var sc = d.getElementsByTagName(s)[0];
			sc.parentNode.insertBefore(o, sc);
			o.src = ('https:' == d.location.protocol ? 'https:' : 'http:') + '//www.jobscore.com/jobs/' + c + '/widget.js';
		})(document, 'script', 'nexonamericainc');
	},
	created() {
		window.addEventListener('scroll', () => (this.scrollY = window.scrollY || document.documentElement.scrollTop));
		axios.get('https://careers.jobscore.com/jobs/nexonamericainc/feed.json').then((response) => {
			this.joblist = response.data;
		});
	},
	destroyed() {
		window.removeEventListener('scroll', this.stickyTabs);
	},
	methods: {
		scrollToId(id) {
			this.$nextTick(() => {
				document.getElementById(id).scrollIntoView({
					behavior: 'smooth',
				});
			});
		},
	},
};
</script>

<style lang="scss" scoped>
@font-face {
	font-family: arrow-icons;
	src: url('data:application/font-woff;charset=utf-8;base64, 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');
	font-weight: 400;
	font-style: normal;
}

#careers {
	background-color: #fff;
	padding-top: 56px;
	padding-bottom: 50px;
	line-height: normal;
	font-family: KlavikaNX Regular;
}

.careers {
	&__header {
		position: relative;
		.hero {
			position: relative;
			width: 100%;
			height: 790px;
			&-image {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-repeat: no-repeat;
				background-image: url('~@/images/corporate/careers/hero.jpg');
				background-size: cover;
				background-position: 60%;
			}
			&-content {
				position: relative;
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: flex-end;
				.hero-body {
					width: 65%;
					text-align: center;
					padding-bottom: 80px;
					.hero-title {
						font-weight: 700;
						text-transform: uppercase;
						color: #b5e115;
						font-size: 48px;
						font-family: KlavikaNX Medium;
					}
					.hero-statement {
						color: #fff;
						font-size: 18px;
					}
				}
			}
			&-badge {
				background-image: url('~@/images/corporate/badge-great-place-to-work.png');
				background-position: 50% center;
				background-size: 100%;
				background-repeat: no-repeat;
				width: 123px;
				height: 200px;
				right: 30px;
				top: 40px;
				position: absolute;
			}
		}

		&__tabs {
			display: flex;
			width: 100%;
			height: 60px;
			background-color: #b5e115;
			justify-content: center;
			z-index: 2;

			.tab {
				display: flex;
				align-items: center;
				height: 100%;
				color: #0f3654;
				font-size: 16px;
				text-transform: uppercase;
				font-weight: 700;
				padding: 0 30px;
				border-right: 2px solid #eee;
				font-family: KlavikaNX Medium;
				text-decoration: none;
				opacity: 1;
				transition: opacity 0.25s;
				&:hover {
					opacity: 0.8;
					transition: opacity 0.25s;
				}
				&:last-child {
					border: none;
				}
				&:hover {
					cursor: pointer;
				}
			}
			&--sticky {
				position: fixed;
				top: 56px;
				left: 0;
			}
		}
	}

	#open-positions,
	#benefits-and-perks,
	#featured-jobs,
	#life-at-nexon {
		scroll-margin-top: 116px;
	}

	&.is-sticky {
		#open-positions {
			margin-top: 96px;
		}
	}

	&__section {
		width: 100%;
		max-width: 1024px;
		margin: 40px auto;
		&#life-at-nexon,
		&#benefits-and-perks,
		&#featured-jobs {
			max-width: 100%;
		}
		&#open-positions {
			margin-bottom: 0px;
		}
		&#benefits-and-perks {
			margin-top: 0px;
		}

		&#featured-jobs {
			margin-bottom: 62px;
		}
		&__title {
			width: 100%;
			text-align: center;
			text-transform: uppercase;
			font-weight: 700;
			font-size: 48px;
			color: #0047bb;
			font-family: KlavikaNX Medium;
		}

		&#benefits-and-perks {
			max-width: 100%;
		}
		.benefits {
			width: 80%;
			margin: 10px auto 0;
			&__grid {
				padding: 20px;
				border-radius: 20px;
				background-color: #0064b2;
				display: flex;
				justify-content: center;
				flex-wrap: wrap;
				&:after {
					content: '';
					display: inline-block;
					position: relative;
					margin: 5px;
					width: 271px;
					height: 274px;
					background-repeat: no-repeat;
					background-image: url('~@/images/corporate/careers/icons/button-office.png');
					background-size: contain;
				}
				.benefit {
					position: relative;
					margin: 5px;
					width: 271px;
					height: 274px;
					background-repeat: no-repeat;
					background-image: url('~@/images/corporate/careers/icons/button.png');
					background-size: contain;
					display: flex;
					flex-direction: column;
					&:hover {
						background-image: url('~@/images/corporate/careers/icons/button-hover.png');
					}
					&__title {
						width: 100%;
						height: 40%;
						padding: 40px;
						text-align: center;
						color: #0047bb;
						font-size: 18px;
						display: flex;
						justify-content: center;
						align-items: center;
						white-space: pre-line;
						&--pl,
						&--nl {
							line-height: 1;
						}
					}
					&__icon {
						width: 100%;
						height: 50%;
						text-align: center;
					}
					&__detail {
						padding: 0 40px;
						display: none;
						height: 100%;
						width: 100%;
						color: #0047bb;
						font-size: 15px;
						justify-content: center;
						align-items: center;
						text-align: center;
						line-height: 1.14;
						&--pl,
						&--nl,
						&--de {
							line-height: 1;
						}
					}

					&:hover {
						.benefit__title,
						.benefit__icon {
							display: none;
						}

						.benefit__detail {
							display: flex;
						}
					}
				}
			}
		}
		.life-carousel {
			width: 70%;
			margin-left: auto;
			margin-right: auto;
			margin-top: 10px;
			&__item {
				border: 2px solid #032153;
				img {
					width: 100%;
					height: auto;
					pointer-events: none;
				}
			}
			::v-deep .slick-prev {
				left: -80px;
			}
			::v-deep .slick-next {
				right: -80px;
			}
		}

		.featured-carousel {
			margin-top: 10px;
			&__item {
				display: flex;
				background-color: #b4e114;
				min-height: 510px;
				&__left,
				&__right {
					flex: 0 0 50%;
					max-width: 50%;
				}
				&__left {
					background-repeat: no-repeat;
					background-size: cover;
					background-position: 50%;
				}
				&__right {
					border-left: 2px solid #fff;
					padding: 4% 3% 5%;
					.featured {
						width: 90%;
						&__title {
							color: #0047bb;
							font-family: KlavikaNX Medium;
							font-size: 36px;
							text-transform: uppercase;
							line-height: 32px;
						}
						&__subtitle {
							margin-top: 5px;
							color: #0a3256;
							font-size: 28px;
							line-height: 28px;
						}
						&__description {
							margin-top: 50px;
							font-size: 20px;
							color: #0a3256;
						}
						&__apply {
							text-transform: uppercase;
							display: inline-block;
							margin-top: 70px;
							min-height: 42px;
							background-color: #0047bb;
							font-size: 22px;
							text-decoration: none;
							color: #fff;
							padding: 10px 70px;
							opacity: 1;
							transition: opacity 0.3s;
							&:hover {
								cursor: pointer;
								opacity: 0.8;
								transition: opacity 0.3s;
							}
						}
					}
				}
			}
			::v-deep .slick-prev {
				left: 16px;
				text-shadow: 2px 0 0 #fff, -1px -3px 0 #fff, -3px 0 0 #fff, 0 3px 0 #fff, 3px 0 0 #fff, 0 -3px 0 #fff;
			}
			::v-deep .slick-next {
				right: 16px;
				text-shadow: 2px 0 0 #fff, -1px -3px 0 #fff, -3px 0 0 #fff, 0 3px 0 #fff, 3px 0 0 #fff, 0 -3px 0 #fff;
			}
		}
		::v-deep .slick-slide {
			pointer-events: none;
		}
		::v-deep .slick-active {
			z-index: 1;
			pointer-events: auto;
		}
		::v-deep .slick-dots {
			li {
				margin: 0 8px;
				button {
					padding: 0;
					&:before {
						font-size: 20px;
						color: #0047bb;
						opacity: 1;
					}
				}
				&.slick-active {
					button {
						&:before {
							color: #01ace4;
						}
					}
				}
			}
		}

		::v-deep .slick-arrow {
			text-shadow: 2px 0 0 #fff, -1px -3px 0 #fff, -3px 0 0 #fff, 0 3px 0 #fff, 3px 0 0 #fff, 0 -3px 0 #fff;
			width: 42px;
			height: 70px;
			z-index: 1;
			&:before {
				text-transform: none;
				font-family: arrow-icons;
				color: #0047bb;
				font-size: 70px;
				opacity: 1;
			}
			&:hover {
				&:before {
					color: #01ace4;
				}
			}
		}

		::v-deep .slick-prev {
			&:before {
				content: 'prev';
			}
		}
		::v-deep .slick-next {
			&:before {
				content: 'next';
			}
		}
	}
}

@media only screen and (max-width: 1024px) {
	.careers {
		&__header {
			.hero {
				height: 460px;
				background-color: #0d161d;
				&-image {
					background-image: url('~@/images/corporate/careers/hero-mobile.jpg');
					background-size: 100%;
					background-position: top;
				}
				&-content {
					position: relative;
					width: 100%;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: flex-end;
					.hero-body {
						padding-top: 40px;
						padding-bottom: 10px;
						width: 100%;
						background: linear-gradient(rgba(13, 22, 29, 0), rgba(13, 22, 29, 0.6), #0d161d 40%);

						.hero-title {
							font-size: 28px;
						}
						.hero-statement {
							padding: 10px 15px;
							font-size: 14px;
						}
					}
				}
				&-badge {
					width: 98px;
					height: 156px;
					top: 118px;
				}
			}

			&__tabs {
				position: fixed;
				top: 56px;
				left: 0;
				padding: 10px 20px;
				height: auto;
				background: linear-gradient(#0d161d 50%, rgba(13, 22, 29, 0.7));
				flex-wrap: wrap;
				align-items: center;
				z-index: 3;
				.tab {
					background-color: #a8d119;
					width: 48%;
					margin: 2px;
					border: none;
					font-size: 14px;
					justify-content: center;
					padding: 0 10px;
					height: 40px;
				}
			}
		}

		#open-positions,
		#benefits-and-perks,
		#featured-jobs,
		#life-at-nexon {
			scroll-margin-top: 164px;
		}
		&.is-sticky {
			#open-positions {
				margin-top: 30px;
			}
		}

		&__section {
			margin: 30px auto;
			&__title {
				font-size: 28px;
			}
			.jobscore-jobs {
				padding: 0 20px;
			}
			&#featured-jobs {
				margin-bottom: 53px;
			}

			.benefits {
				margin: 0;
				width: 100%;
				padding: 10px 20px 0px 20px;
				&__grid {
					padding: 5px;
					&:after {
						width: 180px;
						height: 182px;
					}
					.benefit {
						width: 180px;
						height: 182px;
						&__title {
							font-size: 12px;
							padding: 0 20px;
						}
						&__icon {
							height: 60%;
							transform: scale(0.65);
							position: absolute;
							bottom: 10px;
						}
						&__detail {
							padding: 0 24px;
							font-size: 10px;
							line-height: 1.1;
							&--de {
								line-height: 1;
								padding-left: 20px;
								padding-right: 20px;
							}
						}
					}
				}
			}

			.featured-carousel {
				margin-top: 10px;
				padding: 0 40px;

				&__item {
					min-height: 400px;
					&__left,
					&__right {
						flex: 0 0 100%;
						max-width: 100%;
					}
					&__left {
						position: absolute;
						width: 100%;
						height: 100%;
						top: 0;
						left: 0;
						opacity: 0.1;
						pointer-events: none;
					}
					&__right {
						z-index: 1;
						padding: 20px 20px 60px;
						.featured {
							width: 100%;
							text-align: center;
							&__title {
								font-size: 22px;
								line-height: 22px;
							}
							&__subtitle {
								font-size: 18px;
								line-height: 18px;
							}
							&__description {
								margin-top: 20px;
								font-size: 14px;
							}
							&__apply {
								margin-top: 20px;
							}
						}
					}
				}
				::v-deep .slick-prev {
					left: -30px;
				}
				::v-deep .slick-next {
					right: -30px;
				}
			}

			.life-carousel {
				::v-deep .slick-prev {
					left: -30px;
				}
				::v-deep .slick-next {
					right: -30px;
				}
			}
			::v-deep .slick-prev,
			::v-deep .slick-next {
				width: 24px;
				height: 42px;
				&:before {
					font-size: 42px;
				}
			}
		}
	}
}

@media only screen and (max-width: 600px) {
	.careers {
		&__section {
			.featured-carousel {
				margin-top: 10px;
				padding: 0 40px;

				&__item {
					&__right {
						.featured {
							&__apply {
								font-size: 16px;
								padding: 10px 30px;
								min-width: 220px;
							}
						}
					}
				}
			}
		}
	}
}

@media only screen and (max-width: 400px) {
	.careers {
		&__section {
			.featured-carousel {
				&__item {
					&__right {
						.featured {
							&__apply {
								min-width: 100%;
							}
						}
					}
				}
			}
		}
	}
}

@media (min-width: 768px) and (max-width: 1024px) {
	.careers {
		&__header {
			.hero {
				&-image {
					background-position: 50%;
				}
			}
		}
	}
}
</style>
